import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  imports: [RouterOutlet],
  standalone: true,
})
export class EmployeeComponent {}
